import { sql } from 'kysely';

import { db } from ':fat/database/kysely';
import { ping as pingDatabaseWorker, query } from ':fat/messaging/entities/databaseWorker/actions';
import { ping as pingMainPage } from ':fat/messaging/entities/mainPage/actions';

export async function sanityCheck() {
  // TODO: Check that all browser dependencies we'll need are present and that
  // everything was loaded successfully

  try {
    // Weird import to avoid circular dependency
    await Promise.all([pingMainPage(), pingDatabaseWorker()]);
  } catch (error: unknown) {
    let errorMessage = 'Could not ping a neighbor';
    if (error instanceof Error) {
      errorMessage += `: ${error.message}`;
    }
    return { success: false, errorMessage };
  }

  try {
    const result = await query(
      db.selectNoFrom([sql`'from blockchain worker'`.as('sanity_value')]).compile(),
    );
    if (result[0].sanity_value !== 'from blockchain worker') {
      return { success: false, errorMessage: 'Query did not return expected result' };
    }
  } catch (error: unknown) {
    if (error instanceof Error) {
      return { success: false, errorMessage: `Query was not successful: ${error.message}` };
    }
  }

  return { success: true };
}
